export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const GET_SINGLE_PRODUCT = 'GET_SINGLE_PRODUCT';
export const GET_SINGLE_PRODUCT_BEGIN = 'GET_SINGLE_PRODUCT_BEGIN';
export const GET_SINGLE_PRODUCT_SUCCESS = 'GET_SINGLE_PRODUCT_SUCCESS';
export const GET_SINGLE_PRODUCT_ERROR = 'GET_SINGLE_PRODUCT_ERROR';
export const TOGGLE_CART_MODAL = 'TOGGLE_CART_MODAL';
export const ADD_TO_CART = 'ADD_TO_CART';
export const GET_CART_TOTALS = 'GET_CART_TOTALS';
export const TOGGLE_CART_ITEM_AMOUNT = 'TOGGLE_CART_ITEM_AMOUNT';
export const CLEAR_CART = 'CLEAR_CART';
export const COUNT_CART_VAT = 'COUNT_CART_VAT';
export const COUNT_GRAND_TOTAL = 'COUNT_GRAND_TOTAL';
export const TOGGLE_CHECKOUT_MODAL = 'TOGGLE_CHECKOUT_MODAL';